import { setDeckSourceContent, touchContentUpdatedAt } from "../model/surfDeck.js";
import { surfBedrockChat } from "./surfBedrockChat.js";
export function seedDeckContextFromSource(deck, sourceText, sourceTitle) {
    const excerpt = sourceText.trim().slice(0, 8000);
    const ctx = {
        summary: (sourceTitle || deck.title).trim(),
        keyEntities: [],
        themes: [],
        sourceExcerpts: excerpt ? [excerpt] : [],
    };
    return setDeckSourceContent(setDeckContext(deck, ctx), sourceText);
}
function slideDigest(deck) {
    return deck.slides
        .map((s, i) => {
        const texts = s.layers
            .filter((l) => l.type === "text")
            .map((l) => l.content.trim())
            .filter(Boolean)
            .join(" | ");
        return `Slide ${i + 1}: ${texts || "(vuota)"}`;
    })
        .join("\n");
}
export async function extractDeckContext(cfg, deck) {
    const raw = await surfBedrockChat(cfg, {
        feature: "surf.deck.context",
        systemText: [
            "You extract document context for a presentation deck.",
            "Return ONLY valid JSON:",
            '{"summary":"...","keyEntities":["..."],"themes":["..."],"sourceExcerpts":["..."]}',
            "Grounding is conceptual/illustrative — no charts or numeric claims.",
        ].join(" "),
        userText: `Deck title: ${deck.title}\n\n${slideDigest(deck)}`,
        maxTokens: 2048,
    });
    const parsed = JSON.parse(raw.replace(/^```json\s*/i, "").replace(/```\s*$/i, ""));
    return {
        summary: String(parsed.summary ?? "").trim(),
        keyEntities: Array.isArray(parsed.keyEntities) ? parsed.keyEntities.map(String) : [],
        themes: Array.isArray(parsed.themes) ? parsed.themes.map(String) : [],
        sourceExcerpts: Array.isArray(parsed.sourceExcerpts) ? parsed.sourceExcerpts.map(String) : [],
    };
}
export function setDeckContext(deck, ctx) {
    return touchContentUpdatedAt({ ...deck, deckContext: ctx });
}
export async function ensureDeckContext(cfg, deck) {
    if (deck.deckContext?.summary?.trim())
        return deck;
    const ctx = await extractDeckContext(cfg, deck);
    return setDeckContext(deck, ctx);
}
